export default "__VITE_ASSET__rHuaNGFO__"